import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../../assets/css/onboarding.css";
import "../../../../assets/css/stepper.css";
import { toast } from "sonner";
import {
  callToast,
  prepareSiteList,
  showErrorMessages,
} from "../../../../../src/services/utilityFunctions.js";
import { getLocalStorageData } from "../../../../../src/services/axiosComponent";
import { useGlobalState } from "../../../../../src/services/hostelConst.js";
import Select from "react-select";
import { selectStyle } from "../../../../services/constant";
import { closeModal } from "../../../../services/redux/reducers/modalSlice";
import { useSelector, useDispatch } from "react-redux";
import {
  addExaminationSeries,
  updateExaminationSeries,
  getExaminationSeriesDetails,
} from "../../../../services/Users-services.js";
import {
  getAcademicYearList,
  getDivisionList,
  getDivisionSectionList,
} from "../../../../services/Academic-Services.js";

const AddSeriesForm = (props) => {
  const { refresh, navigate } = props;
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const modal = useSelector((state) => state.modal);

  const [currentStep, setCurrentStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(modal.isEditing);

  // Options state
  const [academicYearOptions, setAcademicYearOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [siteOptions, setSiteOptions] = useState([]);
  const [divisionOptions, setDivisionOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);

  // Loading states
  const [isAcademicYearLoading, setIsAcademicYearLoading] = useState(false);
  const [isSiteOptionsLoading, setIsSiteOptionsLoading] = useState(false);
  const [isDivisionLoading, setIsDivisionLoading] = useState(false);
  const [isSectionLoading, setIsSectionLoading] = useState(false);

  // Searchable states
  const [isSiteSearchable, setIsSiteSearchable] = useState(true);
  const [isRegionSearchable, setIsRegionSearchable] = useState(true);

  const seriesTypeOptions = [
    { value: "TEST", label: "Test" },
    { value: "PRACTICE", label: "Practice" },
    { value: "ASSESSMENT", label: "Assessment" },
  ];

  const prepareFormData = (data = null) => {
    return {
      seriesInfo: {
        name: data?.name || "",
        description: data?.description || "",
        academicYear: {
          value: data?.academicYearId || "",
          label: data?.academicYearName || "",
        },
        seriesType: {
          value: data?.seriesType || "",
          label: data?.seriesType || "",
        },
      },
      academicInfo: {
        region: {
          value: data?.regionId || "",
          label: data?.regionName || "",
        },
        site: {
          value: data?.siteId || "",
          label: data?.siteName || "",
        },
        division: {
          value: data?.classId || "",
          label: data?.className || "",
        },
        section: {
          value: data?.sectionId || "",
          label: data?.sectionName || "",
        },
      },
    };
  };

  const [formData, setFormData] = useState(prepareFormData());

  const getSeriesDetailsData = async () => {
    setLoadingData(true);
    try {
      var res = await getExaminationSeriesDetails(modal.data._ID);
      if (res.status === "success") {
        setData(res.data);
        setFormData(prepareFormData(res.data));
      } else {
        dispatch(closeModal());
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error fetching series details:", error);
      showErrorMessages({
        data: { message: "Failed to fetch series details" },
        navigate,
      });
    }
    setLoadingData(false);
  };

  const handleChange = (step, field, value) => {
    setErrors({});

    if (step === "academicInfo") {
      if (field === "region") {
        setFormData((prev) => ({
          ...prev,
          academicInfo: {
            ...prev.academicInfo,
            region: value,
            site: { value: "", label: "" },
            division: { value: "", label: "" },
            section: { value: "", label: "" },
          },
        }));
        if (value?.value) {
          getSiteList(value.value);
        }
        return;
      }

      if (field === "site") {
        setFormData((prev) => ({
          ...prev,
          academicInfo: {
            ...prev.academicInfo,
            site: value,
            division: { value: "", label: "" },
            section: { value: "", label: "" },
          },
        }));
        if (value?.value) {
          getDivisionOptions(formData.academicInfo.region.value, value.value);
        }
        return;
      }

      if (field === "division") {
        setFormData((prev) => ({
          ...prev,
          academicInfo: {
            ...prev.academicInfo,
            division: value,
            section: { value: "", label: "" },
          },
        }));
        if (value?.value) {
          getSectionOptions(
            value.value,
            formData.academicInfo.region.value,
            formData.academicInfo.site.value
          );
        }
        return;
      }

      if (field === "section") {
        setFormData((prev) => ({
          ...prev,
          academicInfo: {
            ...prev.academicInfo,
            section: value,
          },
        }));
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [step]: { ...prev[step], [field]: value },
    }));
  };

  // API calls for fetching options
  const getAcademicYearOptions = async () => {
    setIsAcademicYearLoading(true);
    try {
      var res = await getAcademicYearList();
      if (res.status === "success") {
        const list = res.data.entityList.map((item) => ({
          value: item._ID,
          label: item.NAME,
        }));
        setAcademicYearOptions(list);
      } else {
        showErrorMessages({ data: res, navigate });
      }
    } catch (error) {
      console.error("Error fetching academic years:", error);
      showErrorMessages({
        data: { message: "Failed to fetch academic years" },
        navigate,
      });
    }
    setIsAcademicYearLoading(false);
  };

  const getRegionList = async () => {
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = JSON.parse(localStorage.getItem("regionList"));
    if (
      list.length == 1 &&
      list[0].value == data._REGION &&
      data["_REGION_ACCESS_"] == null
    ) {
      setIsRegionSearchable(false);
      handleChange("academicInfo", "region", {
        value: list[0].value,
        label: list[0].label,
      });
    }
    setRegionOptions(list);
  };

  const getSiteList = async (regionId, query) => {
    setIsSiteOptionsLoading(true);
    var data = await JSON.parse(localStorage.getItem("profileDetails"));
    var list = await prepareSiteList(regionId, navigate, query);

    if (
      list.length == 1 &&
      list[0].value == data._SITE &&
      data["_SITE ACCESS_"] == null
    ) {
      setIsSiteSearchable(false);
      handleChange("academicInfo", "site", {
        value: list[0].value,
        label: list[0].label,
      });
    }

    setIsSiteOptionsLoading(false);
    if (list.length == 0) {
      setErrors((prev) => ({
        ...prev,
        site: "No site available for this region",
      }));
    } else {
      setErrors((prev) => ({
        ...prev,
        site: "",
      }));
    }
    setSiteOptions(list);
  };

  const getDivisionOptions = async (regionId, siteId) => {
    setIsDivisionLoading(true);
    try {
      var res = await getDivisionList({
        status: "Y",
        regionId: regionId,
        siteId: siteId,
      });
      if (res.status === "success") {
        const list = res.data.entityList.map((item) => ({
          value: item._ID,
          label: item.NAME,
        }));
        setDivisionOptions(list);
      } else {
        showErrorMessages({ data: res, navigate });
        setDivisionOptions([]);
      }
    } catch (error) {
      console.error("Error fetching divisions:", error);
      showErrorMessages({
        data: { message: "Failed to fetch divisions" },
        navigate,
      });
      setDivisionOptions([]);
    }
    setIsDivisionLoading(false);
  };

  const getSectionOptions = async (divisionId, regionId, siteId) => {
    setIsSectionLoading(true);
    try {
      var res = await getDivisionSectionList({
        classId: divisionId,
        status: "Y",
        regionId: regionId,
        siteId: siteId,
      });
      if (res.status === "success") {
        const list = res.data.entityList.map((item) => ({
          value: item._ID,
          label: item.NAME,
        }));
        setSectionOptions(list);
      } else {
        showErrorMessages({ data: res, navigate });
        setSectionOptions([]);
      }
    } catch (error) {
      console.error("Error fetching sections:", error);
      showErrorMessages({
        data: { message: "Failed to fetch sections" },
        navigate,
      });
      setSectionOptions([]);
    }
    setIsSectionLoading(false);
  };

  const validateFields = () => {
    const newErrors = {};

    if (currentStep === 1) {
      const { name, description, academicYear, seriesType } =
        formData.seriesInfo;

      if (!name?.trim()) newErrors.name = "Name is required";
      if (!description?.trim())
        newErrors.description = "Description is required";
      if (!academicYear.value)
        newErrors.academicYear = "Academic Year is required";
      if (!seriesType.value) newErrors.seriesType = "Series Type is required";
    } else if (currentStep === 2) {
      const { region, site, division, section } = formData.academicInfo;

      if (!region.value) newErrors.region = "Region is required";
      if (!site.value) newErrors.site = "Site is required";
      if (!division.value) newErrors.division = "Division is required";
      if (!section.value) newErrors.section = "Section is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getCurrentStepKey = () => {
    return currentStep === 1 ? "seriesInfo" : "academicInfo";
  };

  const handleNext = async () => {
    if (validateFields()) {
      if (currentStep < 2) {
        setCurrentStep(currentStep + 1);
      } else {
        await submitForm();
      }
    }
  };

  const submitForm = async () => {
    setLoading(true);

    const dataToSubmit = {
      name: formData.seriesInfo.name,
      description: formData.seriesInfo.description,
      academicYearId: formData.seriesInfo.academicYear.value,
      seriesType: formData.seriesInfo.seriesType.value,
      regionId: formData.academicInfo.region.value,
      siteId: formData.academicInfo.site.value,
      classId: formData.academicInfo.division.value,
      sectionId: formData.academicInfo.section.value,
      organizationId:
        getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
    };

    if (data) {
      dataToSubmit.id = data._ID;
    }

    try {
      const res = data
        ? await updateExaminationSeries(dataToSubmit, data._ID)
        : await addExaminationSeries(dataToSubmit);

      if (res.status === "success") {
        callToast(
          "success",
          data ? "Updated" : "Created",
          `Series ${data ? "updated" : "added"} successfully`
        );
        await refresh({ columnRefresh: false, isLoading: false });
        dispatch(closeModal());
      } else {
        const resError = showErrorMessages({
          data: res,
          navigate,
        });

        if (resError != null || resError != undefined) {
          var step = 2;
          var error = {};
          Object.entries(resError).map(([key, value]) => {
            step = Math.min(step, value.step);
            error[key] = value.message;
          });
          setErrors(error);
          setCurrentStep(step);
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      callToast("error", "Error", "Failed to submit series");
    }

    setLoading(false);
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  useEffect(() => {
    getAcademicYearOptions();
    getRegionList();

    if (modal.isEditing) {
      getSeriesDetailsData();
    }
  }, []);

  if (loadingData) {
    return (
      <center>
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </center>
    );
  }

  return (
    <section className="login-content">
      <div className="m-5 mt-1">
        <div className="d-flex">
          <div className="w-100">
            <div className="stepper mb-3">
              <div className="d-flex justify-content-between">
                <div className={`step ${currentStep === 1 ? "active" : ""}`}>
                  Series Info
                </div>
                <div className={`step ${currentStep === 2 ? "active" : ""}`}>
                  Academic Info
                </div>
              </div>
            </div>

            <form>
              {currentStep === 1 ? (
                <SeriesInfoStep
                  formData={formData.seriesInfo}
                  errors={errors}
                  academicYearOptions={academicYearOptions}
                  seriesTypeOptions={seriesTypeOptions}
                  isAcademicYearLoading={isAcademicYearLoading}
                  onChange={handleChange}
                />
              ) : (
                <AcademicInfoStep
                  formData={formData.academicInfo}
                  errors={errors}
                  regionOptions={regionOptions}
                  siteOptions={siteOptions}
                  divisionOptions={divisionOptions}
                  sectionOptions={sectionOptions}
                  isSiteOptionsLoading={isSiteOptionsLoading}
                  isDivisionLoading={isDivisionLoading}
                  isSectionLoading={isSectionLoading}
                  isSiteSearchable={isSiteSearchable}
                  isRegionSearchable={isRegionSearchable}
                  onChange={handleChange}
                  getSiteList={getSiteList}
                />
              )}

              <div className="d-flex justify-content-end mt-4 gap-2">
                {currentStep > 1 && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleBack}
                    disabled={loading}
                  >
                    Back
                  </button>
                )}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleNext}
                  disabled={loading}
                >
                  {loading ? (
                    <div className="spinner-border text-light" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : currentStep < 2 ? (
                    "Next"
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

// Step Components
const SeriesInfoStep = ({
  formData,
  errors,
  academicYearOptions,
  seriesTypeOptions,
  isAcademicYearLoading,
  onChange,
}) => (
  <>
    <div className="mb-3">
      <label className="form-label">Name</label>
      <input
        type="text"
        className="form-control"
        placeholder="Enter Series Name"
        value={formData.name}
        onChange={(e) => onChange("seriesInfo", "name", e.target.value)}
      />
      {errors.name && <small className="text-danger">{errors.name}</small>}
    </div>
    <div className="mb-3">
      <label className="form-label">Description</label>
      <textarea
        className="form-control"
        placeholder="Enter Series Description"
        rows="1"
        value={formData.description}
        onChange={(e) => onChange("seriesInfo", "description", e.target.value)}
      />
      {errors.description && (
        <small className="text-danger">{errors.description}</small>
      )}
    </div>

    <div className="row mb-3">
      <div className="col-md-6">
        <label className="form-label">Academic Year</label>
        <Select
          options={academicYearOptions}
          value={formData.academicYear.label ? formData.academicYear : null}
          styles={selectStyle}
          onChange={(newValue) =>
            onChange(
              "seriesInfo",
              "academicYear",
              newValue || { value: "", label: "" }
            )
          }
          components={isAcademicYearLoading ? { DropdownIndicator } : null}
          isSearchable={!isAcademicYearLoading}
          placeholder="Select Academic Year"
          className="basic-single"
          classNamePrefix="select"
        />
        {errors.academicYear && (
          <small className="text-danger">{errors.academicYear}</small>
        )}
      </div>

      <div className="col-md-6">
        <label className="form-label">Series Type</label>
        <Select
          options={seriesTypeOptions}
          value={formData.seriesType.label ? formData.seriesType : null}
          styles={selectStyle}
          onChange={(newValue) =>
            onChange(
              "seriesInfo",
              "seriesType",
              newValue || { value: "", label: "" }
            )
          }
          placeholder="Select Series Type"
          className="basic-single"
          classNamePrefix="select"
        />
        {errors.seriesType && (
          <small className="text-danger">{errors.seriesType}</small>
        )}
      </div>
    </div>
  </>
);

const AcademicInfoStep = ({
  formData,
  errors,
  regionOptions,
  siteOptions,
  divisionOptions,
  sectionOptions,
  isSiteOptionsLoading,
  isDivisionLoading,
  isSectionLoading,
  isSiteSearchable,
  isRegionSearchable,
  onChange,
  getSiteList,
}) => (
  <>
    <div className="mb-3">
      <label className="form-label">Region</label>
      <Select
        options={regionOptions}
        value={formData.region.label ? formData.region : null}
        styles={selectStyle}
        onChange={(newValue) =>
          onChange(
            "academicInfo",
            "region",
            newValue || { value: "", label: "" }
          )
        }
        noOptionsMessage={() => {
          return !isRegionSearchable
            ? "Region Access not available"
            : "No matches found";
        }}
        isSearchable={isRegionSearchable}
        placeholder="Select Region"
        className="basic-single"
        classNamePrefix="select"
      />
      {errors.region && <small className="text-danger">{errors.region}</small>}
    </div>

    <div className="mb-3">
      <label className="form-label">Site</label>
      <Select
        options={siteOptions}
        value={formData.site.label ? formData.site : null}
        styles={selectStyle}
        onChange={(newValue) =>
          onChange("academicInfo", "site", newValue || { value: "", label: "" })
        }
        onInputChange={(inputValue, { action }) => {
          if (action === "input-change") {
            getSiteList(formData.region.value, inputValue);
          }
        }}
        components={isSiteOptionsLoading ? { DropdownIndicator } : null}
        noOptionsMessage={() => {
          return !isSiteSearchable
            ? "Site Access Not available"
            : "No matches found";
        }}
        isSearchable={isSiteSearchable}
        placeholder="Select Site"
        className="basic-single"
        classNamePrefix="select"
        isDisabled={!formData.region.value}
      />
      {errors.site && <small className="text-danger">{errors.site}</small>}
    </div>

    <div className="mb-3">
      <label className="form-label">Division</label>
      <Select
        options={divisionOptions}
        value={formData.division.label ? formData.division : null}
        styles={selectStyle}
        onChange={(newValue) =>
          onChange(
            "academicInfo",
            "division",
            newValue || { value: "", label: "" }
          )
        }
        components={isDivisionLoading ? { DropdownIndicator } : null}
        isSearchable={!isDivisionLoading}
        placeholder="Select Division"
        className="basic-single"
        classNamePrefix="select"
        isDisabled={!formData.site.value}
      />
      {errors.division && (
        <small className="text-danger">{errors.division}</small>
      )}
    </div>

    <div className="mb-3">
      <label className="form-label">Section</label>
      <Select
        options={sectionOptions}
        value={formData.section.label ? formData.section : null}
        styles={selectStyle}
        onChange={(newValue) =>
          onChange(
            "academicInfo",
            "section",
            newValue || { value: "", label: "" }
          )
        }
        components={isSectionLoading ? { DropdownIndicator } : null}
        isSearchable={!isSectionLoading}
        placeholder="Select Section"
        className="basic-single"
        classNamePrefix="select"
        isDisabled={!formData.division.value}
      />
      {errors.section && (
        <small className="text-danger">{errors.section}</small>
      )}
    </div>
  </>
);

const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        className="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default AddSeriesForm;
